<template>
  <b-sidebar
    position="static"
    :reduce="false"
    :fullheight="true"
    mobile="hidden"
    type="is-dark"
    open
  >
    <div class="sidebar--fixed">
      <div class="block">
        <img src="~@/assets/logo.png" alt="Pivot Analysis">
      </div>
      <p class="is-size-6 has-text-grey">Select a game below to see a projected boxscore</p>
    </div>
    <div class="sidebar--scrollable">
      <div class="block" v-for="[day, games] of Object.entries(gamesByDate)" :key="day">
        <div class="is-size-7 has-text-left is-uppercase has-text-grey-lighter">{{ day }}</div>
        <div
          class="game"
          :class="{active: isActive(game)}"
          v-for="game in games"
          :key="game.n"
          @click="navigate(game.slug)"
        >
          <div class="game-summary">
            <div class="has-text-left">
              <div :class="{ 'winner': visitorWins(game) }">{{ game.visitor }}</div>
              <div :class="{ 'winner': !visitorWins(game) }">{{ game.home }}</div>
            </div>
            <div class="has-text-right has-text-weight-bold">
              <div :class="{ 'winner': visitorWins(game) }">{{ visitorPoints(game) }}</div>
              <div :class="{ 'winner': !visitorWins(game) }">{{ homePoints(game) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import { teams } from '../teams'
import { games } from '../../public/wnbasim-latest.json'

export default {
  name: 'GameNav',
  data () {
    return {
      games,
    }
  },
  computed: {
    readyGames () {
      return this.games.filter((item) => Array.isArray(item.boxscore))
    },
    gamesByDate () {
      const byDate = {}
      const { readyGames } = this
      readyGames.reverse().forEach((game) => {
        if (byDate[game.date]) {
          byDate[game.date].push(game)
        } else {
          byDate[game.date] = [game]
        }
      })
      return byDate
    },
  },
  methods: {
    navigate (slug) {
      this.$router.push({ name: 'game', params: { id: slug } })
    },
    visitorPoints (game) {
      if (!game.boxscore) return 0
      const team = teams[game.visitor]
      const boxscore = game.boxscore.filter((row) => row.Team === team.short)
      const summary = boxscore.pop()
      return summary.PTS
    },
    homePoints (game) {
      if (!game.boxscore) return 0
      const team = teams[game.home]
      const boxscore = game.boxscore.filter((row) => row.Team === team.short)
      const summary = boxscore.pop()
      return summary.PTS
    },
    visitorWins (game) {
      return this.visitorPoints(game) > this.homePoints(game)
    },
    isActive (game) {
      return this.$route.params.id === game.slug
    },
  },
}
</script>

<style lang="scss" scoped>
.game-summary {
  display: grid;
  grid-template-columns: 75% 25%;
  width: 100%;
}

/deep/ .sidebar-content {
  padding: 1rem;
  overflow-y: hidden;
  padding: 0;

  .sidebar {
    &--fixed {
      padding: 1rem;
    }

    &--scrollable {
      padding: .75rem;
      overflow-y: auto;
    }
  }
}

.game {
  border-top: 1px solid #666;
  padding: .5rem;
  color: #eee;

  &.active {
    border-left: 4px solid $gold;
    color: $gold;
  }

  &:hover {
    background-color: $gold;
    color: #333;
    cursor: pointer;
  }
}

.scrollable {
  overflow-y: auto;

  .block {
    margin: 0;
    padding: 1rem;
  }
}

.winner {
  font-weight: 900;
}
</style>
